
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class Photo extends Vue {
  @Prop() readonly src!: string;
  @Prop({default: false, type: Boolean}) readonly action!: boolean;
}
